<div class="font-weight-bold">{{ text }}</div>
